import CancelIcon from "@mui/icons-material/Cancel"
import SaveIcon from "@mui/icons-material/Save"
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material"
import dayjs from "dayjs"
import { getAnalytics, logEvent } from "firebase/analytics"
import {
  collection,
  deleteDoc,
  doc,
  getFirestore,
  setDoc,
} from "firebase/firestore"
import { FunctionComponent, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import Color from "../Color"
import { Collection } from "../Enum"
import { RecordType } from "../Type"

const RecordTypeDialog: FunctionComponent<{
  userId: string
  recordTypes: RecordType[]
  onClickClose: () => void
}> = ({ userId, recordTypes, onClickClose }) => {
  const intl = useIntl()

  const [recordTypeName, setRecordTypeName] = useState<string>("")

  // Firebase
  const firestore = getFirestore()
  const analytics = getAnalytics()
  const recordTypeRef = collection(
    firestore,
    `/${Collection.Users}/${userId}/${Collection.RecordTypes}`
  )

  const deleteRecordType = (recordType: RecordType) => {
    deleteDoc(doc(firestore, recordTypeRef.path, recordType.id))
      .then(() => {
        console.log(`RecType with id ${recordType.id} deleted successfully`)
        onClickClose()
      })
      .catch((error) => {
        console.error(error)
        onClickClose()
      })
  }

  const saveRecordType = () => {
    const currentTime = dayjs().valueOf()
    // Saves a new record type
    const recTypeDocRef = doc(recordTypeRef)
    setDoc(recTypeDocRef, {
      name: recordTypeName,
      insertDate: currentTime,
    })
      .then(() => {
        console.log("Record Type created successfully")
        onClickClose()
        logEvent(analytics, "web_rec_type_created")
      })
      .catch((error) => {
        console.error(error)
        onClickClose()
      })

    logEvent(analytics, "web_create_rec_type_clicked")
  }

  return (
    <div>
      <DialogTitle>
        <FormattedMessage id="dialog.title.record.types" />
      </DialogTitle>
      <DialogContent>
        <Grid container direction="row" spacing={1}>
          {recordTypes.map((recordType, index) => (
            <Grid key={index}>
              <Chip
                label={recordType.name}
                onDelete={() => deleteRecordType(recordType)}
              />
            </Grid>
          ))}
        </Grid>
        <TextField
          margin="normal"
          fullWidth
          multiline
          label={intl.formatMessage({
            id: "dialog.record.type.name",
          })}
          value={recordTypeName}
          onChange={(event: any) => {
            setRecordTypeName(event.target.value)
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            logEvent(analytics, "web_rec_type_cancelled")
            onClickClose()
          }}
          startIcon={<CancelIcon />}
        >
          <FormattedMessage id="dialog.button.cancel" />
        </Button>
        <Button
          onClick={() => {
            logEvent(analytics, "web_create_record_type_clicked")
            saveRecordType()
          }}
          variant="contained"
          style={{ background: Color.Primary }}
          startIcon={<SaveIcon />}
        >
          <FormattedMessage id="dialog.button.save" />
        </Button>
      </DialogActions>
    </div>
  )
}

export default RecordTypeDialog
